import React, { useState, useEffect } from "react";
import { MDBRow, MDBCol } from 'mdb-react-ui-kit';
import DateAppuntamento from "./dateAppuntamento";
export default function Consulenza({
    setMessage,
    setPreferenzeGiorni,
    }) {

    const [GiornoPreferito1, setGiornoPreferito1] = useState(false)
    const [GiornoPreferito2, setGiornoPreferito2] = useState(false)
    const [GiornoPreferito3, setGiornoPreferito3] = useState(false)
    
    useEffect(() => {
		setPreferenzeGiorni(`Prima Scelta:${GiornoPreferito1}\nSeconda Scelta:${GiornoPreferito2}\nTerza Scelta:${GiornoPreferito3}`)
	});
 
	return (
		<>
            <MDBRow>
                <MDBCol>
                    <div className="field">
                        <MDBRow>
                            <MDBRow>
                                <label className='customLab' >Giorni e orari preferiti</label>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol className="p-2">
                                    <DateAppuntamento 
                                        setGiorniPreferiti={setGiornoPreferito1}
                                        numeroData='Prima Preferenza'
                                        GiorniPreferiti={GiornoPreferito1}
                                    />
                                </MDBCol>
                                <MDBCol className="p-2">
                                    <DateAppuntamento 
                                        setGiorniPreferiti={setGiornoPreferito2}
                                        numeroData='Seconda Preferenza'
                                        GiorniPreferiti={GiornoPreferito2}
                                    />
                                </MDBCol>
                                <MDBCol className="p-2">
                                    <DateAppuntamento 
                                        setGiorniPreferiti={setGiornoPreferito3}
                                        numeroData='Terza Preferenza'
                                        GiorniPreferiti={GiornoPreferito3}
                                    />
                                </MDBCol>
                                
                            </MDBRow>
                        </MDBRow>
                        {/* <input type="text" placeholder="16 dicembre ore 10.30; 19 dicembre ore 15:30" name="preferenzeGiorni" id="preferenzeGiorni" onChange={e => setPreferenzeGiorni(e.target.value)} /> */}
                    </div>
                </MDBCol>
            </MDBRow>

            <MDBRow>
                <MDBCol>
                    <div className="field">
                        <label className='customLab' >Richiesta *</label>
                        <textarea className="message-field" type="textarea" placeholder="Inserire dettagli richiesta" name="message" id="message" onChange={e => setMessage(e.target.value)} />
                    </div>
                </MDBCol>
            </MDBRow>
        </>
	);
}